import {exeRequest} from '../utils/APIUtils'

export default {
    //getResume : async  (dates, concessionnaireId) => exeRequest(`/dasboard/getResume?dateDebut=2023-04-01&dateFin=2023-12-31&concessionnaireId=${concessionnaireId}`, "GET")
    getResume : async  (dates, concessionnaireId) => exeRequest(`/dasboard/getResume?dateDebut=${dates.debut}&dateFin=${dates.fin}&concessionnaireId=${concessionnaireId}`, "GET")
}